export const messages = {
  en: {
    addParkingSpaceApply: {
      title: 'Parking Space Application',
      carNum: 'License Plate',
      carBrand: 'Car Brand',
      carType: 'Vehicle Type',
      carColor: 'Color',
      applyPersonName: 'Applicant',
      applyPersonLink: 'Applicant Phone',
      remark: 'Remarks',
      requiredCarNum: 'License plate is required',
      invalidCarNum: 'Invalid license plate format',
      requiredCarBrand: 'Car brand is required',
      maxCarBrand: 'Car brand max 50 characters',
      requiredCarType: 'Vehicle type is required',
      requiredCarColor: 'Color is required',
      maxCarColor: 'Color max 12 characters',
      requiredApplyPersonName: 'Applicant name is required',
      maxApplyPersonName: 'Applicant name max 64 characters',
      requiredApplyPersonLink: 'Applicant phone is required',
      maxApplyPersonLink: 'Applicant phone max 11 characters',
      maxRemark: 'Remarks max 300 characters',
      placeholderCarNum: 'Required, please enter license plate',
      placeholderCarBrand: 'Required, please enter car brand',
      placeholderCarType: 'Required, please select vehicle type',
      placeholderCarColor: 'Required, please enter color',
      placeholderApplyPersonName: 'Required, please enter applicant',
      placeholderApplyPersonLink: 'Required, please enter applicant phone',
      placeholderRemark: 'Optional, please enter remarks',
      selectOwner: 'Select Owner',
      page: {
        title: 'Parking Space Application',
        subtitle: 'Submit a parking space application for a vehicle',
        infoTitle: 'Application Information'
      }
    }
  },
  zh: {
    addParkingSpaceApply: {
      title: '车位申请',
      carNum: '车牌号',
      carBrand: '汽车品牌',
      carType: '车辆类型',
      carColor: '颜色',
      applyPersonName: '申请人',
      applyPersonLink: '申请人电话',
      remark: '备注',
      requiredCarNum: '车牌号不能为空',
      invalidCarNum: '车牌号格式错误',
      requiredCarBrand: '汽车品牌不能为空',
      maxCarBrand: '汽车品牌不能超过50位',
      requiredCarType: '车辆类型不能为空',
      requiredCarColor: '颜色不能为空',
      maxCarColor: '颜色不能超过12位',
      requiredApplyPersonName: '申请人不能为空',
      maxApplyPersonName: '申请人名称不能超过64位',
      requiredApplyPersonLink: '申请人电话不能为空',
      maxApplyPersonLink: '申请人电话不能超过11位',
      maxRemark: '备注不能超过300位',
      placeholderCarNum: '必填，请填写车牌号',
      placeholderCarBrand: '必填，请填写汽车品牌',
      placeholderCarType: '必填，请选择车辆类型',
      placeholderCarColor: '必填，请填写颜色',
      placeholderApplyPersonName: '必填，请填写申请人',
      placeholderApplyPersonLink: '必填，请填写申请人电话',
      placeholderRemark: '选填，请填写备注',
      selectOwner: '选择车主',
      page: {
        title: '车位申请',
        subtitle: '为车辆提交车位租赁申请',
        infoTitle: '申请信息'
      }
    }
  }
}